// Profile interests (`profiles.interests`, a text[] of these ids).
//
// ⚠️ The ONE client list — onboarding, the profile editor and the public
// profile all read it (they each had their own copy before). Nothing reads
// interests yet beyond the profile itself, so onboarding must not promise
// they personalise anything.
export const INTEREST_OPTIONS = [
  { id: 'wellness',      label: 'Self-Care & Wellness', emoji: '🧘', color: '#4DAAAA' },
  { id: 'skills',        label: 'Behavior Support',     emoji: '🧩', color: '#E07A5F' },
  { id: 'career',        label: 'Career Growth',        emoji: '📈', color: 'var(--brand-primary)' },
  { id: 'family',        label: 'Family Caregiving',    emoji: '❤️', color: '#9B7EC8' },
  { id: 'communication', label: 'Communication',        emoji: '💬', color: '#D4A03C' },
  { id: 'policy',        label: 'Rights & Advocacy',    emoji: '⚖️', color: '#5B8C6F' },
];

export const interestLabels = Object.fromEntries(INTEREST_OPTIONS.map((o) => [o.id, o.label]));
